import React, { useEffect, useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import INFO from "../../data/user";
import SEO from "../../data/seo";

import "./styles/contact.css";

const Contact = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const form = useRef();

	const [formData, setFormData] = useState({
		name: "",
		email: "",
		message: "",
	});

	const [status, setStatus] = useState("");

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (!formData.name || !formData.email || !formData.message) {
			setStatus("Please fill out all fields before submitting.");
			return;
		}

		emailjs
			.sendForm(
				"service_tdrob6b",
				"template_gc23s7u",
				form.current,
				"FtJwgHwoKmFjTe_Mb",
			)
			.then(
				(result) => {
					console.log("Email sent successfully!", result.text);
					setStatus(
						"Message sent successfully! I’ll get back to you soon.",
					);
					setFormData({ name: "", email: "", message: "" });
				},
				(error) => {
					console.error("Failed to send email:", error.text);
					setStatus(
						"Failed to send message. Please try again later.",
					);
				},
			);
	};

	return (
		<React.Fragment>
			<div className="content-wrapper">
				<div className="contact-container">
					<h2 className="section-title">Let’s Connect</h2>

					<div className="subtitle contact-subtitle">
						Reach me directly at{" "}
						<a
							className="contact-inline-links"
							href={`mailto:${INFO.main.email}`}
						>
							{INFO.main.email}
						</a>
						. I usually respond within 24 hours, though it might
						take a bit longer during busy periods. Alternatively,
						feel free to use the contact form below. I’ll get back
						to you as soon as possible. Finally, if you prefer to
						connect on social media, you can find me on{" "}
						<a
							className="contact-inline-links ig"
							href={INFO.socials.instagram}
							target="_blank"
							rel="noreferrer"
						>
							Instagram
						</a>{" "}
						or{" "}
						<a
							className="contact-inline-links"
							href={INFO.socials.linkedin}
							target="_blank"
							rel="noreferrer"
						>
							LinkedIn
						</a>
						. I look forward to hearing from you!
					</div>
				</div>

				<form
					ref={form}
					className="contact-form"
					onSubmit={handleSubmit}
				>
					<div className="inputs-container">
						<div className="name-email">
							<div className="contact-form-inputs">
								<label htmlFor="name">Name</label>
								<input
									type="text"
									id="name"
									name="name"
									value={formData.name}
									onChange={handleChange}
									placeholder="Enter your name"
									required
								/>
							</div>
							<div className="contact-form-inputs">
								<label htmlFor="email">Email</label>
								<input
									type="email"
									id="email"
									name="email"
									value={formData.email}
									onChange={handleChange}
									placeholder="Enter your email"
									required
								/>
							</div>
						</div>

						<div className="contact-form-inputs">
							<label htmlFor="message">Message</label>
							<textarea
								id="message"
								name="message"
								value={formData.message}
								onChange={handleChange}
								placeholder="Type your message here..."
								rows="6"
								required
							></textarea>
						</div>
					</div>

					<button type="submit" className="contact-button">
						Send Message
					</button>

					{status && <p className="form-status">{status}</p>}
				</form>
			</div>
		</React.Fragment>
	);
};

export default Contact;
